const groupBy = <T extends Record<string, unknown>>(
  elements: readonly T[],
  attribute: keyof T | ((element: T) => string),
): { name: string; elements: T[] }[] => {
  const groups: { name: string; elements: T[] }[] = [];

  for (const element of elements) {
    const name =
      typeof attribute === 'string'
        ? element[attribute]
        : typeof attribute === 'function'
          ? attribute(element)
          : '';

    if (typeof name !== 'string') {
      throw new Error(
        `Grouping attribute (${String(attribute)}) value must be a string`,
      );
    }

    const group = groups.find((g) => g.name === name) ?? {
      name,
      elements: [] as T[],
    };

    group.elements.push(element);

    if (!groups.includes(group)) {
      groups.push(group);
    }
  }

  return groups;
};

export default groupBy;
